export const getPostalCodeSelectFormattedValue = (value: string[]): string => {
  return value.join(', ');
}
